import { gql } from "@apollo/client";

export const UPDATE_STATUS_WITH_COMMENT = gql`
  mutation UpdateStatusWithComment(
    $filters_config: FiltersConfigInput!
    $user_status_key: Int!
    $user_comment_html: String!
    $user_comment_plain: String!
    $apply_async: Boolean
    $reopen_events: [EventInput]
  ) {
    set_user_status_and_comment_v2(
      filters_config: $filters_config
      user_status_key: $user_status_key
      user_comment_html: $user_comment_html
      user_comment_plain: $user_comment_plain
      apply_async: $apply_async
      reopen_events: $reopen_events
    ) {
      task_id
    }
  }
`;

export const UPDATE_STATUS_CACHE = gql`
  fragment ActualStatus on FindingsView {
    actual_status {
      key
      category
      type
      name
    }
  }
`;

export const GET_SYSTEM_EVENTS = gql`
  query getSystemEvents($system_use_case: SystemEventUseCase) {
    system_event_definitions(system_use_case: $system_use_case) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
